import { useState, useEffect } from 'react';
import authService from '../services/authService';
import { useTelegram } from '../../../shared/hooks/useTelegram';

/**
 * Custom hook for authentication
 */
export function useAuth() {
  const { user: tgUser, initData, initDataRaw } = useTelegram();
  const [user, setUser] = useState(null);
  const [isAuthorized, setIsAuthorized] = useState(null); // null = checking, true = authorized, false = denied
  const [authMessage, setAuthMessage] = useState('');
  const [authToken, setAuthToken] = useState(null); // Store token for Socket.io

  useEffect(() => {
    // Check for token in URL (for browser access)
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (token) {
      // Verify token with backend
      verifyTokenAuth(token);
      // Clean up URL
      window.history.replaceState({}, document.title, window.location.pathname);
      return;
    }

    // Telegram WebApp auth
    if (tgUser && initData) {
      verifyTelegramAuth(initData, tgUser);
    } else if (tgUser === undefined) {
      // Still loading
      return;
    } else {
      setIsAuthorized(false);
      setAuthMessage('Не удалось получить данные пользователя Telegram');
    }
  }, [tgUser, initData]);

  const verifyTelegramAuth = async (initData, userData) => {
    try {
      const response = await authService.verifyTelegramAuth(initData, userData);

      if (response.authorized) {
        setIsAuthorized(true);
        setUser(response.user);
      } else {
        setIsAuthorized(false);
        setAuthMessage(response.message || 'Доступ запрещен');
      }
    } catch (error) {
      console.error('Auth verification error:', error);
      setIsAuthorized(false);
      setAuthMessage('Ошибка при проверке авторизации');
    }
  };

  const verifyTokenAuth = async (token) => {
    try {
      const response = await authService.verifyTokenAuth(token);

      if (response.authorized) {
        setIsAuthorized(true);
        setAuthToken(token); // Store token for Socket.io
        setUser(response.user);
      } else {
        setIsAuthorized(false);
        setAuthMessage(response.message || 'Недействительный или истекший токен');
      }
    } catch (error) {
      console.error('Token verification error:', error);
      setIsAuthorized(false);
      setAuthMessage('Ошибка при проверке токена');
    }
  };

  return {
    user,
    isAuthorized,
    authMessage,
    authToken,
    initData,
    initDataRaw  // Return raw string for WebSocket auth
  };
}
